var React = require('react');

function ChevronsHorizontal (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},React.createElement("path",{"style":{"stroke":"none","fillRule":"nonzero","fill":"rgb(47.058824%,46.27451%,46.27451%)","fillOpacity":"1"},"d":"M 30.398438 45.425781 L 22.792969 37.5 L 19.40625 41.023438 L 30.398438 52.5 L 41.414062 41.023438 L 38.007812 37.5 M 30.398438 14.574219 L 38.007812 22.5 L 41.390625 18.976562 L 30.398438 7.5 L 19.382812 18.976562 L 22.792969 22.5 Z M 30.398438 14.574219 "})));
}

ChevronsHorizontal.defaultProps = {"width":"60px","height":"60px","viewBox":"0 0 60 60","version":"1.1"};

module.exports = ChevronsHorizontal;

ChevronsHorizontal.default = ChevronsHorizontal;
